import { Job } from "..";

export default function getStepClassName(job: Job) {
  let state = job.state;

  if (
    job.state === "finished" ||
    job.state === "timed_out" ||
    job.state === "expired"
  ) {
    if (
      job.type === "script" ||
      job.type === "trigger" ||
      job.type === "job_group"
    ) {
      if (job.passed) {
        state = "passed";
      } else if (job.softFailed) {
        state = "failed-soft";
      } else if (job.state === "canceled") {
        state = "canceled";
      } else {
        state = "failed";
      }
    }
    if (job.type === "manual") {
      if (job.state === "finished" && job.unblockedAt) {
        state = "unblocked";
      }
    }
  } else if (job.state === "canceled") {
    state = job.passed ? "canceled-passed" : "canceled";
  } else if (
    job.type === "job_group" &&
    job.state === "running" &&
    job.passed === false
  ) {
    state = "failing";
  }

  const classList = [
    "flex",
    "items-center",
    "build-pipeline-job",
    `build-pipeline-job-${job.type.replace(/_/g, "-")}`,
    `build-pipeline-state-${state}`,
  ];

  if (
    job.type === "job_group" &&
    job.state === "blocked" &&
    job.hasSoftFailedJobs()
  ) {
    classList.push("build-pipeline-state-soft-failed");
  }

  return classList.join(" ");
}
